import { useContext } from 'react';

import { AppContext, AppStateContext } from '../context';

export function useAppState(): AppContext {
  return useContext<AppContext>(AppStateContext);
}
